import CryptoJS from 'crypto-js';

const secretKey = 'e9NHdT3GU6wBdWlw3RTqvrShGzyerRl4BaMhFeUI3v4j6U0opW5a19HQHDAHHCrhYXq8oG6D'; 


const api = process.env.REACT_APP_API_URL;

class Request {

   
    static encryptData(data) {
        return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
    }

   
    static encryptEndpoint(endpoint) {
        return CryptoJS.AES.encrypt(endpoint, secretKey).toString();
    }

    static decryptData(encryptedData) {
        const secretKey = 'e9NHdT3GU6wBdWlw3RTqvrShGzyerRl4BaMhFeUI3v4j6U0opW5a19HQHDAHHCrhYXq8oG6D';
        const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
        const decryptedData = bytes.toString(CryptoJS.enc.Utf8); 
        return JSON.parse(decryptedData);
    }
    

   
    static async create_pay_CreditCard_S(USER_ID,currency,amount) {
      
        const encryptedPayload = this.encryptData({ ARG:{USER_ID:USER_ID,currency:currency,amount:amount,API:"V2"} });
        const encryptedEndpoint = this.encryptEndpoint('/stripe/init_payment'); 

        const response = await fetch(`${api}${encryptedEndpoint}`, {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }), 
        });

        const responseData = await response.json();

        

        return this.decryptData(responseData.data);
    }


    static async create_pay_CreditCard_DC(USER_ID,CURRENCY,AMOUNT) {
      
        const encryptedPayload = this.encryptData({ ARG:{USER_ID:USER_ID,CURRENCY:CURRENCY,AMOUNT:AMOUNT,API:"V2"} });
        const encryptedEndpoint = this.encryptEndpoint('/Stripe/EXECUTE_PAYMENT'); 

        const response = await fetch(`${api}${encryptedEndpoint}`, {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }), 
        });

        const responseData = await response.json();

        

        return this.decryptData(responseData.data);
    }


    static async get_deposit_methods_cryptapi() {
      
        const encryptedPayload = this.encryptData({});
        const encryptedEndpoint = this.encryptEndpoint('/CryptApi/GET_DEPOSIT_METHOD'); 

        const response = await fetch(`${api}${encryptedEndpoint}`, {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }), 
        });
        const responseData = await response.json();
        return this.decryptData(responseData.data);
    }

    static async create_deposit_request_cryptapi(userId, cryptCurrency, fiatCurrency, customer_email, customer_name) {
      
        const encryptedPayload = this.encryptData({ user_id: userId, crypto_currency: cryptCurrency, fiat_currency: fiatCurrency, customer_email: customer_email, customer_name: customer_name });
        const encryptedEndpoint = this.encryptEndpoint('/CryptApi/CREATE_DEPOSIT_REQUEST'); 

        const response = await fetch(`${api}${encryptedEndpoint}`, {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }), 
        });
        const responseData = await response.json();
        return this.decryptData(responseData.data);
    }

    


    static async create_pay_CreditCard_DCP(USER_ID,CURRENCY,AMOUNT, EMAIL,PHONE,NAME) {

        const encryptedPayload = this.encryptData({ ARG:{USER_ID:USER_ID,CURRENCY:CURRENCY,AMOUNT:AMOUNT,API:"V2",customer_email:EMAIL,customer_phone:PHONE,customer_name:NAME} });
        const encryptedEndpoint = this.encryptEndpoint('/DCPController/EXECUTE_PAYMENT');

        const response = await fetch(`${api}${encryptedEndpoint}`, {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }), 
        });

        const responseData = await response.json();

        

        return this.decryptData(responseData.data);
    }


    static async create_Bank_Withdraw(USER_ID,CURRENCY,AMOUNT,IBAN,FULLNAME) { 
      
        const encryptedPayload = this.encryptData({ ARG:{user_id:USER_ID,currency:CURRENCY,amount:AMOUNT,iban:IBAN,full_name:FULLNAME} });
        const encryptedEndpoint = this.encryptEndpoint('/SkinsController/WITHDRAW_REQUEST_BANK'); 

        const response = await fetch(`${api}${encryptedEndpoint}`, {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }), 
        });

        const responseData = await response.json();

        

        return this.decryptData(responseData.data);
    }

    /* static async create_Bank_Withdraw(USER_ID,CURRENCY,AMOUNT,IBAN) { 
      
        const encryptedPayload = this.encryptData({ ARG:{user_id:USER_ID,currency:CURRENCY,amount:AMOUNT,iban:IBAN} });
        const encryptedEndpoint = this.encryptEndpoint('/SkinsController/WITHDRAW_REQUEST_BANK'); 

        const response = await fetch(`${api}${encryptedEndpoint}`, {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }), 
        });

        const responseData = await response.json();

        

        return this.decryptData(responseData.data);
    } */
    

    static async deposit_Voucher(USER_ID,CODE) { 
      
        const encryptedPayload = this.encryptData({ user_id:USER_ID,voucher_code:CODE });
        const encryptedEndpoint = this.encryptEndpoint('/Voucher/REFUND_VOUNCHER_USER'); 

        const response = await fetch(`${api}${encryptedEndpoint}`, {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }), 
        });

        const responseData = await response.json();

        

        return this.decryptData(responseData.data);
    }





   



}

export default Request;


